export default "__VITE_ASSET__d392f6de__"